const TILT_SELECTOR = '[data-tilt]';
const TILT_MIN_WIDTH = 1034;
const TILT_LOADER_ATTRIBUTE = 'data-tilt-loader';
const tiltLoaderUrl = new URL('../vendors/vanilla-tilt.loader.js', import.meta.url);

let tiltLoadPromise = null;

function canInitTilt() {
  return window.innerWidth >= TILT_MIN_WIDTH;
}

function addTiltElements(elements, value) {
  if (!(value instanceof Element)) {
    return;
  }

  if (value.matches(TILT_SELECTOR)) {
    elements.add(value);
  }

  value.querySelectorAll(TILT_SELECTOR).forEach((element) => {
    elements.add(element);
  });
}

function resolveTiltElements(target = document) {
  const elements = new Set();

  if (typeof target === 'string') {
    document.querySelectorAll(target).forEach((element) => {
      addTiltElements(elements, element);
    });

    return [...elements];
  }

  if (
    target instanceof Element ||
    target instanceof Document ||
    target instanceof DocumentFragment
  ) {
    if (target instanceof Element) {
      addTiltElements(elements, target);
    } else {
      target.querySelectorAll(TILT_SELECTOR).forEach((element) => {
        elements.add(element);
      });
    }

    return [...elements];
  }

  if (
    target instanceof NodeList ||
    target instanceof HTMLCollection ||
    Array.isArray(target)
  ) {
    Array.from(target).forEach((element) => {
      addTiltElements(elements, element);
    });
  }

  return [...elements];
}

function loadTiltScript() {
  if (!canInitTilt()) {
    return Promise.resolve(null);
  }

  if (window.VanillaTilt) {
    return Promise.resolve(window.VanillaTilt);
  }

  if (tiltLoadPromise) {
    return tiltLoadPromise;
  }

  tiltLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      `script[${TILT_LOADER_ATTRIBUTE}="true"]`
    );

    const handleLoad = () => resolve(window.VanillaTilt || null);
    const handleError = () => {
      tiltLoadPromise = null;
      reject(new Error('Failed to load VanillaTilt.'));
    };

    if (existingScript) {
      existingScript.addEventListener('load', handleLoad, { once: true });
      existingScript.addEventListener('error', handleError, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.type = 'module';
    script.src = tiltLoaderUrl.toString();
    script.setAttribute(TILT_LOADER_ATTRIBUTE, 'true');
    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });
    document.body.append(script);
  });

  return tiltLoadPromise;
}

export async function initDataTilt(target = document) {
  const elements = resolveTiltElements(target);

  if (!elements.length || !canInitTilt()) {
    return [];
  }

  const VanillaTilt = await loadTiltScript();
  if (!VanillaTilt) {
    return [];
  }

  const freshElements = elements.filter((element) => !element.vanillaTilt);
  if (!freshElements.length) {
    return [];
  }

  VanillaTilt.init(freshElements);
  return freshElements;
}

function runInitialDataTilt() {
  initDataTilt().catch((error) => {
    console.error(error);
  });
}

window.initDataTilt = initDataTilt;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runInitialDataTilt, { once: true });
} else {
  runInitialDataTilt();
}
